import { render, staticRenderFns } from "./BaikeCate.vue?vue&type=template&id=d238c51c&scoped=true&"
import script from "./BaikeCate.vue?vue&type=script&lang=js&"
export * from "./BaikeCate.vue?vue&type=script&lang=js&"
import style0 from "./BaikeCate.vue?vue&type=style&index=0&id=d238c51c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d238c51c",
  null
  
)

export default component.exports